import { useEffect, useState } from "react";
import useDebounce from "./../../customHook/useDebounce";
import Icon from "../../assets/icons/Icon";
import ColorPickerwithmodal from "./ColorPickerwithmodal";

const ColorPickerWithSearchBar = ({
  startimage,
  startimageicon,
  placeholder,
  handlecolorbuttonClick,
  showpickcolorbton,
  value, // This is the prop value from parent
  onChange,
  label
}) => {
  // Initialize inputValue with the prop value
  const [inputValue, setInputValue] = useState(value || "");
  const debouncedValue = useDebounce(inputValue, 500);

  // Sync inputValue with parent value when it changes
  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    if (handlecolorbuttonClick) {
      handlecolorbuttonClick();
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleColorSelect = (color) => {
    setInputValue(color);
    if (onChange) {
      onChange(color);
    }
  };

  const handleConfirmColor = () => {
    closeModal();
  };

  return (
    <>
      <div className="flex flex-col w-full relative">
        {label && (
          <label className={`mb-1`}>
            {label}
          </label>
        )}
        <div
          className="flex gap-2 items-center border-1 border-[#d7d5e2] hover:border-[#408dfb] focus-within:shadow-[0_0_0_3px_rgba(64,_141,_251,_0.16)] text-[#000000] w-full rounded-lg"
          style={{ height: "34px" }}
        >
          {startimage && (
            <span className="w-9 pl-1 inline-block text-gray-500 hover:text-gray-600">
              <Icon type={startimageicon} />
            </span>
          )}
          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder={placeholder}
            className="inline-block w-full px-[8px] py-[5px] h-[34px] outline-none border-none"
            style={{ height: "100%" }}
          />
          {inputValue && (
            <span
              className="inline-block w-8 text-gray-400 hover:text-blue-500 pr-2 bg-white"
              onClick={() => {
                setInputValue("");
                if (onChange) onChange("");
              }}
              style={{ cursor: "pointer" }}
            >
              <Icon type="remove" />
            </span>
          )}

          {showpickcolorbton && (
            <span
              className="inline-block w-8 h-3 pr-2"
              style={{ backgroundColor: inputValue }}
            ></span>
          )}

          {showpickcolorbton && (
            <span
              className="px-2 h-[34px] text-nowrap text-gray-500 border-l-1 border-[#d7d5e2] cursor-pointer items-center flex justify-center"
              onClick={openModal}
              style={{ height: "34px", display: "flex", alignItems: "center" }}
            >
              Pick color
            </span>
          )}

          {isModalOpen && (
            <ColorPickerwithmodal
              value={inputValue}
              onChange={handleColorSelect}
              onConfirm={handleConfirmColor}
              onCancel={closeModal}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ColorPickerWithSearchBar;